import { baseApi } from 'services'

import { PaginatedResults, State } from '@/types/unlock'

export const statesDataApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllStates: builder.query<PaginatedResults<State[]>, Partial<State> | undefined>({
      query: (params = {}) => ({
        method: 'GET',
        url: `v2/us-states/`,
        params,
      }),
      providesTags: ['USStates'],
    }),
    createState: builder.mutation<State, Partial<State>>({
      query: (state) => ({
        method: 'POST',
        url: 'v2/us-states/',
        body: state,
      }),
      invalidatesTags: ['USStates'],
    }),
    updateState: builder.mutation<State, Partial<State>>({
      query: (state) => ({
        method: 'PATCH',
        url: `v2/us-states/${state.uuid}/`,
        body: state,
      }),
      invalidatesTags: ['USStates'],
    }),
  }),
})

export const {
  useGetAllStatesQuery,
  useLazyGetAllStatesQuery,
  useCreateStateMutation,
  useUpdateStateMutation,
} = statesDataApi
